import { render } from "./Slides.vue?vue&type=template&id=a72f7e46&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"

import "./Slides.vue?vue&type=style&index=0&id=a72f7e46&lang=scss&scoped=true"

import exportComponent from "/opt/gitea/webhooker/hooks/dscontrol/kraken/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72f7e46"]])

export default __exports__